import {createAction} from '@reduxjs/toolkit';

import type {Channel} from '@mattermost/types/channels';
import type {User} from 'features/users';

export const receivedPartOfUsersInChannel = createAction<[Channel['id'], User[]]>('sidebar/actions/receivedPartOfUsersInChannel');
